import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from 'react';
import { Space, Dropdown } from 'antd';
import { DownOutlined } from '@ant-design/icons';
var DropdownSelect = function (_a) {
    var _b;
    var options = _a.options, value = _a.value, onClick = _a.onClick;
    var selectedLabel = ((_b = options.find(function (opt) { return opt.key === value; })) === null || _b === void 0 ? void 0 : _b.label) || 'Select';
    return (_jsx(Dropdown, { menu: { items: options, onClick: onClick }, children: _jsxs(Space, { children: [selectedLabel, _jsx(DownOutlined, {})] }) }));
};
export default DropdownSelect;
